export default function StepTitleSection({
  title,
  description,
  children,
}: {
  title: React.ReactNode;
  description: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <div className="space-y-2 pb-4">
      {title && <h2 className="text-lg font-bold">{title}</h2>}
      {description && <div className="text-sm pb-2">{description}</div>}
      {children}
    </div>
  );
}
